import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClientBill = createAsyncThunk(
  "/clientBill/getAllClientBills",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clientBill/getAllClientBills", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  clientBill: [],
  loading: false,
  error: null,
  isLoading: false,
  searchMessage: null,
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  hasMore: false,
};

const clientBillSlice = createSlice({
  name: "clientBill",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientBill.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientBill.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          const result = action.payload.result || {};
          state.clientBill = result.list || [];
          state.currentPage = Number(result.currentPage) || 1;
          state.totalPages = Number(result.totalPages) || 1;
          state.totalCount = Number(result.totalRecords) || 0;
          state.hasMore = result.hasMore ?? false;
          state.searchMessage = null;
          state.error = null;
        } else {
          state.clientBill = [];
          state.currentPage = 1;
          state.totalPages = 1;
          state.totalCount = 0;
          state.hasMore = false;
          state.error = action?.payload?.result?.message;
          state.searchMessage = action?.payload?.result?.message;
        }
      })
      .addCase(getClientBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});
export default clientBillSlice.reducer;

